import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';
import { IssueState } from '../../types/issue-state';

interface Props {
  onEditStatus: () => void;
  state: IssueState;
}

export const IssuesActionsTableMenu = ({ onEditStatus, state }: Props) => {
  const { t } = useTranslation(['issues', 'common']);

  const permissions = usePermissions();

  const canEditIssue = state !== 'RESOLVED' && state !== 'REJECTED';

  const actions: Action[] = [
    {
      id: 'editStatus',
      label: t('issues:common.actions.editStatus'),
      onClick: onEditStatus,
      disabled: permissions.cannot('update', 'Issues') || !canEditIssue,
      tooltip: !canEditIssue
        ? t('issues:common.cannotEditIssuesTooltip')
        : t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
};
